import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Dialog from '../Dialog';
import PropTypes from 'prop-types';
import {
  Grid,
  TextField as Input,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { Typography } from '../Wrappers/Wrappers';
import { useStyles } from './verifyOTP.styles';
import { useVerifyOTP } from './useVerifyOTP';
import VerifyButton from '../VerifyButton';
import ResendButton from '../ResendButton';

const DIALOG_TITLE = 'Confirm it\'s you';

function VerifyOTP (props) {
  const {
    onVerify,
    onResendOTP,
    onClose,
    open,
    ...otherProps
  } = props;

  const classes = useStyles();

  const {
    isVerifying,
    isResending,
    input,
    otpDigits,
    timeRemaining,
    successMessage,
    subtitle,
    inputRefs,
    error,
    isLimitExceeded,
    handleOtpChange,
    handleOtpKeyDown,
    handleOtpPaste,
    handleVerify,
    handleResend,
  } = useVerifyOTP(open, onVerify, onResendOTP);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        classes: {
          root: classes.dialogContainer,
        },
      }}
      {...otherProps}
    >
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <Grid className={classes.content}>
          <Grid item container className={classNames([classes.titleSpace])}>
            <Grid item container className={classNames([classes.titleTextSpace])}>
              <Typography variant={'h5'} weight={'medium'} className={classes.headingText}>
                {DIALOG_TITLE}
              </Typography>
            </Grid>
            <Grid item container className={classNames([classes.subtitleSpace])}>
              <Typography variant={'body1'} className={classes.subtitleText}>
                {subtitle}
              </Typography>
            </Grid>
          </Grid>

          <Grid item container className={classNames([classes.inputSpace])}>
            <Grid className={classes.otpContainer}>
              {otpDigits.map((digit, index) => (
                <Input
                  name={`otp-${index}`}
                  key={index}
                  variant='outlined'
                  type='text'
                  inputMode='numeric'
                  value={digit}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleOtpKeyDown(index, e)}
                  onPaste={handleOtpPaste}
                  inputRef={(el) => (inputRefs.current[index] = el)}
                  autoFocus={index === 0}
                  disabled={isLimitExceeded}
                  error={!!error?.message}
                  className={classes.otpBox}
                  inputProps={{
                    maxLength: 1,
                    style: { textAlign: 'center' },
                  }}
                />
              ))}
            </Grid>
            {successMessage && (
              <Typography variant='caption' className={classes.successText}>
                {successMessage}
              </Typography>
            )}
            {error && (
              <Typography variant='caption' className={classes.errorText}>
                {error?.message}
              </Typography>
            )}
          </Grid>

          <Grid item container className={classNames([classes.buttonSpace])}>
            <ResendButton
              onClick={handleResend}
              isResending={isResending}
              disabled={isVerifying || isLimitExceeded}
              timeRemaining={timeRemaining}
            />

            <VerifyButton
              onClick={handleVerify}
              showProgress={isVerifying}
              disabled={timeRemaining === 0 || input.otp.length !== 6 || isLimitExceeded}
            />
          </Grid>
        </Grid>
    </Dialog>
  );
}

VerifyOTP.propTypes = {
  onVerify: PropTypes.func,
  onResendOTP: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

VerifyOTP.defaultProps = {
  onVerify: () => {},
  onResendOTP: () => {},
  onClose: () => {},
  open: false,
};

export default observer(VerifyOTP);
